import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=6aa213f2&"
import script from "./SvgImage.vue?vue&type=script&lang=js&"
export * from "./SvgImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa213f2')) {
      api.createRecord('6aa213f2', component.options)
    } else {
      api.reload('6aa213f2', component.options)
    }
    module.hot.accept("./SvgImage.vue?vue&type=template&id=6aa213f2&", function () {
      api.rerender('6aa213f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgImage.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgImage.vue
// module id = 326
// module chunks = 12